module.exports = __webpack_public_path__ + "img/44.91ad2286.png";